import { useSelector, useDispatch } from "react-redux";
import Draggable from "react-draggable";
import {
  Paper,
  Typography,
  IconButton,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ACCOUNT_INITIALIZE } from "../store/actions";
import axios from "axios";
import configData from "../config";
import { useRef } from "react";

const ScrapingProgressModal = () => {
  const dispatcher = useDispatch();
  const account = useSelector((state) => state.account);
  const { scraping_modal, scraping_content, scrape_verification_required, scrape_portal } = account;

  let errorMessage = null;
  let timeLeft = 2 * 60;

  const timerRef = useRef(null);
  const intervalRef = useRef(null);
  const timerStartedRef = useRef(false);

  if (!scraping_modal) return null;

  function handleScrapingProgressClose(){
      dispatcher({
          type: ACCOUNT_INITIALIZE,
          payload: {
              scraping_modal: false,
              scraping_content: null,
              scrape_verification_required: {display: false, image: null, job_id: null},
              scrape_portal: null
          },
      });
  }

  const pollScrapeStatus = (job_id) => {
    const interval = setInterval(async () => {
        try {
            const res = await axios.get(
                `${configData.API_SERVER}scraper_status/?job_id=${job_id}`
            );

            if (res.data.status === "RUNNING") {
                dispatcher({
                    type: ACCOUNT_INITIALIZE,
                    payload: {
                        scraping_content: `RUNNING`
                    },
                });
                return;
            }

            if (res.data.status === "SUCCESS") {
                clearInterval(interval);
                dispatcher({
                    type: ACCOUNT_INITIALIZE,
                    payload: {
                        scraping_content: `SUCCESS: ${res.data.message}`
                    },
                });
                return;
            }

            if (res.data.status === "FAILED") {
                clearInterval(interval);
                dispatcher({
                    type: ACCOUNT_INITIALIZE,
                    payload: {
                        scraping_content: `FAILED : ${res.data.message}`
                    },
                });
                return;
            }

        } catch (e) {
            clearInterval(interval);
            dispatcher({
                type: ACCOUNT_INITIALIZE,
                payload: {
                    scraping_content: `FAILED : ${"Status check failed"}`
                },
            });
        }
    }, 5000);
  };

  function startTimer() {
    let timeLeft = 120;

    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      if (!timerRef.current) return;

      const min = Math.floor(timeLeft / 60);
      const sec = (timeLeft % 60).toString().padStart(2, "0");

      timerRef.current.innerText = `Time Remaining: ${min}:${sec}`;

      // color change
      timerRef.current.style.color = timeLeft <= 10 ? "red" : "black";

      timeLeft--;

      if (timeLeft < 0) {
        clearInterval(intervalRef.current);
        timerStartedRef.current = false;

        dispatcher({
          type: ACCOUNT_INITIALIZE,
          payload: {
            scraping_content: "FAILED: Verification timed out",
            scrape_verification_required: {
              display: false,
              image: null,
              job_id: null
            }
          }
        });
      }
    }, 1000);
  }

  function startTimer() {
    let timeLeft = 120;

    clearInterval(intervalRef.current);

    if (timerRef.current) {
      timerRef.current.innerText = "Time Remaining: 2:00";
    }

    intervalRef.current = setInterval(() => {
      if (!timerRef.current) return;

      const min = Math.floor(timeLeft / 60);
      const sec = (timeLeft % 60).toString().padStart(2, "0");

      timerRef.current.innerText = `Time Remaining: ${min}:${sec}`;
      timerRef.current.style.color = timeLeft <= 10 ? "red" : "black";

      timeLeft--;

      if (timeLeft < 0) {
        clearInterval(intervalRef.current);
        timerStartedRef.current = false;

        dispatcher({
          type: ACCOUNT_INITIALIZE,
          payload: {
            scraping_content: "FAILED: Verification timed out",
            scrape_verification_required: {
              display: false,
              image: null,
              job_id: null
            }
          }
        });
      }
    }, 1000);
  }

  async function handleSubmitVerification(){
    errorMessage = null;
    const verification = document.getElementById("verification").value;
    if(!verification){
      errorMessage = <span className="err_color">Enter {scrape_portal == "foundit" ? "Captcha" : scrape_portal == "naukri" ? "OTP" : "data"} to Submit</span>
      return false
    }

    try {
        dispatcher({
            type: ACCOUNT_INITIALIZE,
            payload: {
                scraping_content: `RUNNING`
            },
        });
        const res = await axios.post(
            `${configData.API_SERVER}submit_verification/`,
            {
                job_id: scrape_verification_required["job_id"],
                verification: verification,
            }
        );

        if (res.data.status === "JOB_EXPIRED") {
          dispatcher({
              type: ACCOUNT_INITIALIZE,
              payload: {
                  scraping_content: "FAILED: Session expired. Start again.",
                  scrape_verification_required: {display: false, image: null, job_id: null}
              },
          });
          return;
        }

        pollScrapeStatus(scrape_verification_required["job_id"]);
    } catch (e) {
      dispatcher({
          type: ACCOUNT_INITIALIZE,
          payload: {
              scraping_content: "FAILED: Captcha or OTP submission failed",
              scrape_verification_required: {display: false, image: null, job_id: null}
          },
      });
    }
  }

  if (
    scrape_verification_required?.display &&
    !timerStartedRef.current
  ) {
    timerStartedRef.current = true;

    setTimeout(() => {
      startTimer();
    }, 200);
  }

  return (<>
    <Draggable handle="#draggable-header">
      <Paper
        elevation={4}
        sx={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 9999,
          width: 400,
          borderRadius: 2,
          cursor: "default",
        }}
      >
        <Box
          id="draggable-header"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 1,
            py: 1,
            cursor: "move",
            color: "#fff",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          <Typography variant="h4">
            Fetching From Portal - {scrape_portal}
          </Typography>

          {!(scraping_content.includes("RUNNING") || scraping_content.includes("VERIFICATION_REQUIRED") || scraping_content.includes("QUEUE")) && 
            <IconButton
              size="small"
              onClick={() => handleScrapingProgressClose()}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        </Box>

        <Box 
          sx={{
            p: 1,
            maxHeight: 200,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: (() => {
                if (!scraping_content) return "text.primary";

                if (scraping_content.includes("RUNNING")) return "info.main";       // blue
                if (scraping_content.includes("SUCCESS")) return "success.main";   // green
                if (scraping_content.includes("FAILED")) return "error.main";      // red
                if (scraping_content.includes("VERIFICATION_REQUIRED")) return "warning.main"; // orange
                if (scraping_content.includes("QUEUE")) return "secondary.main";    // purple

                return "text.primary";
              })(),
              fontWeight: 600,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {scraping_content || "No Content"}
          </Typography>
        </Box>
      </Paper>
    </Draggable>
    <Dialog open={scrape_verification_required?.display} maxWidth="sm" fullWidth>
      <DialogTitle>
        {scrape_portal === "foundit"
          ? "Captcha Verification"
          : "OTP Verification"}
      </DialogTitle>

      <DialogContent>
        {scrape_portal === "foundit" && (
          <Box sx={{ textAlign: "center", p: 3 }}>
              <img
                  src={`data:image/jpeg;base64,${scrape_verification_required?.image}`}
                  alt="captcha"
                  style={{ width: "100%", marginBottom: 20 }}
              />

              <Typography sx={{ mt: 1 }}>Enter the Captcha</Typography>
              <TextField
                  label="Enter Captcha"
                  margin="dense"
                  id="verification"
                  type="text"
                  variant="standard"
                  fullWidth
              />

              <Box
                  sx={{
                      maxWidth: 1000,
                      mx: "auto",
                      mt: 1,
                      px: 2,
                      textAlign: "center",
                  }}
              >
                  <Typography
                    ref={timerRef}
                    sx={{
                      mt: 2,
                      fontSize: "15px",
                      textAlign: "center"
                    }}
                  /> 
              </Box>

              <Typography sx={{ mt: 1, color: "red" }}>
                  {errorMessage}
              </Typography>
          </Box>
        )}

        {scrape_portal === "naukri" && (
          <Box sx={{ textAlign: "center", p: 3 }}>
              <Typography sx={{ mt: 1 }}>Enter the OTP sent to Registered Mobile Number or Mail Id</Typography>
              <TextField
                  label="Enter OTP"
                  margin="dense"
                  id="verification"
                  type="text"
                  variant="standard"
                  fullWidth
              />

              <Typography sx={{ mt: 1, color: "red" }}>
                  {errorMessage}
              </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
              <Button variant="contained" onClick={handleSubmitVerification}>Submit</Button>
              <Button
                  variant="contained"
                  onClick={() => {
                    dispatcher({
                        type: ACCOUNT_INITIALIZE,
                        payload: {
                            scraping_content: "FAILED: Scraping Failed",
                            scrape_verification_required: {display: false, image: null, job_id: null}
                        },
                    });
                    clearInterval(intervalRef.current);
                    timerStartedRef.current = false;
                  }}
              >
                  Close
              </Button>
      </DialogActions>
    </Dialog>
  </>);
};

export default ScrapingProgressModal;